export default __webpack_public_path__ + "static/media/StringQuarterNo8-BenJohnston.e3a7e6e4.mp3";